import React, { FC } from 'react';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import ApplicantCardAddSvg from '@src/svgs/applicant-card-add.svg';
import { PlaceholderProps } from './props';
import './styles.scss';

export const Placeholder: FC<PlaceholderProps> = ({ wrapperClassName, message, onClick }) => {
  return (
    <div
      className={classnames(
        'featured-talent-card-placeholder',
        message && 'featured-talent-card-placeholder--with-content',
        wrapperClassName,
      )}
      onClick={() => message && onClick?.()}
    >
      {!!message && (
        <div className="featured-talent-card-placeholder__content">
          <Svg src={ApplicantCardAddSvg} />

          <div className="featured-talent-card-placeholder__content-message">{message}</div>
        </div>
      )}
    </div>
  );
};
